<template>
	<div class="card" :style="{ transform: 'rotate(' + rotate + 'deg)' }">
		
		<div class="attributes">
			<div v-for="row in attributes" class="row">
				<div
					v-for="attribute in row"
					class="attribute"
					:class="[ attribute.element, attribute.type, attribute.status ]"
					:key="attribute.id"
				>
					<div class="bg"></div>
					<div class="icon"></div>
				</div>
			</div>
		</div>

		<!-- <div class="level">1</div> -->

	</div>
</template>

<script>
import { sample } from '@/js/utils'

export default {
	name: 'card',
	data() {
		return {
			rotate: 0
		}
	},
	props: {
		card: { default: null },
	},
	computed: {
		attributes() {
			const attributes = [ ...this.card.attributes ].sort((a, b) => {
				if (a.element > b.element) return 1
				if (a.element < b.element) return -1
				return 0
			})
			return [
				[ ...attributes.filter((a) => a.type === 'attack') ],
				[ ...attributes.filter((a) => a.type === 'defence') ]
			]
		}
	},
	created() {
		this.rotate = sample([ -2, -1, 0, 1, 2 ])
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'


.card
	width card_width
	height card_height
	background-color darken(dark, 25%)
	background-color light
	padding 2px
	// box-shadow 0 0 0 2px light
	// border 2px solid light
	border-radius 8px
	.attributes
		width 100%
		height 100%
		padding 16px 0
		flex center center
		flex-wrap wrap
		// flex-direction column
		align-content center
		background-color darken(dark, 25%)
		border-radius 8px
		.row
			height 50%
			width 100%
			flex center center
			align-content center
			flex-wrap wrap
		.attribute
			width 32px
			height 32px
			margin 2px
			background center center no-repeat
			background-size 100% auto
			transition 0.4s easeOutQuart
			
			&.attack
				border-radius 50%
			&.defence
				border-radius 2px
			
			&.fire
				background-color #FF5722
			&.ice
				background-color #03A9F4
			&.electric
				background-color #FFC107
			
			&.hidden
				transition 0.25s easeOutQuart
				opacity 0
				transform scale(0.5)
				
			&.attacking
				animation attacking 0.4s easeOutBack
				animation-delay 0.25s
				
	.level
		// display none
		position absolute
		left calc(50% - 12px)
		bottom -12px
		width 24px
		height 24px
		background-color light
		color dark
		// box-shadow 0 0 0 4px dark
		line-height (@height + 3px)
		text-align center
		font-size 1.8rem
		font-weight 700
		border-top-left-radius 50%
		border-top-right-radius 50%
		border-radius 50%


@keyframes attacking
	0%, 100%
		transform scale(1)
	50%
		transform scale(1.3)

</style>
